import * as THREE from 'three';


export function extension_terrain(terrainMesh, opciones = {}) {
  if (!terrainMesh) return;

  terrainMesh.updateWorldMatrix(true, true);
  const terrainBox = new THREE.Box3().setFromObject(terrainMesh);
  const min = terrainBox.min.clone();
  const max = terrainBox.max.clone();

  const widthX = max.x - min.x;
  const depthZ = max.z - min.z;
  const yLevel = min.y;

  const extensionLength = depthZ;

  const geometry = new THREE.PlaneGeometry(widthX, extensionLength, 1, 1);
  geometry.rotateX(-Math.PI / 2);

  // ===== COPIAR TEXTURA DEL TERRENO =====
  let material;

  if (terrainMesh.material && terrainMesh.material.map) {
    const originalMap = terrainMesh.material.map;

    const mapCopy = originalMap.clone();
    mapCopy.needsUpdate = true;

    mapCopy.wrapS = THREE.RepeatWrapping;
    mapCopy.wrapT = THREE.RepeatWrapping;

    // Copiar repeat, offset y rotación
    mapCopy.repeat.copy(originalMap.repeat);
    mapCopy.offset.copy(originalMap.offset);
    mapCopy.rotation = originalMap.rotation;
    mapCopy.center.copy(originalMap.center);

    material = new THREE.MeshStandardMaterial({
      map: mapCopy,
      side: THREE.DoubleSide,
      roughness: terrainMesh.material.roughness ?? 1,
      metalness: terrainMesh.material.metalness ?? 0
    });

  } else {
    material = new THREE.MeshStandardMaterial({
      color: 0xcccccc,
      side: THREE.DoubleSide
    });
  }

  const extension = new THREE.Mesh(geometry, material);

  const centerX = (min.x + max.x) / 2;
  const startZ = max.z + extensionLength / 2;

  extension.position.set(centerX, yLevel, startZ);
  extension.receiveShadow = true;

  if (opciones.scene) {
    opciones.scene.add(extension);
  }

  return extension;
}
